import {api} from '../../../system/api';

export default {
    updateDeliveryNote: (params = {}) => api.put('delivery-notes/'+ params.id +'/update', {...params}, {singleRequest: true}),
};
